document.addEventListener("click", function (e) {
    const opener = e.target.closest('modal-opener');
    if (!opener) return;

    let counter = 0;
    const interval = setInterval(() => {
        const modal = document.querySelector(".quick-add-modal[open]");
        if (modal && BSS_B2B) {

            const variants = modal.querySelectorAll(".variant-item__price");
            if (!variants.length) return;

            const span = variants[0].querySelector('span');
            if (!span) return;

            const priceText = span.textContent
                .trim()
                .replace(/[^\d.,]/g, '');

            const headers = modal.querySelectorAll(
                "span.price-item.price-item--regular"
            );
            const header = headers[1];
            if (!header) return;

            const oldText = header.textContent;

            header.textContent = oldText.replace(
                /[\d.,]+/,
                priceText
            );

            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) clearInterval(interval);
        }
    }, 1);
});
